import { createAction, props } from '@ngrx/store';

export enum SeSidePatientHistoryComponentActions {
    SET_PATIENT = '[SeSidePatientHistoryComponent] SetPatient',
    NO_RESULT = '[SeSidePatientHistoryComponent] NoResult',
    SET_SELECTED_ITEM = '[SeSidePatientHistoryComponent] SetSelectedItem',
    PRINT_PREVIEW = '[SeSidePatientHistoryComponent] PrintPreview',
}

export const seSidePatientHistoryComponentSetPatient =
    createAction(SeSidePatientHistoryComponentActions.SET_PATIENT, props<{ formType: any; patientId: string; isAllBuSearch?: boolean }>());

export const seSidePatientHistoryComponentNoResult =
    createAction(SeSidePatientHistoryComponentActions.NO_RESULT, props<{ formType: any; message: string }>());

export const seSidePatientHistoryComponentSetSelectedItem =
    createAction(SeSidePatientHistoryComponentActions.SET_SELECTED_ITEM, props<{ formType: any; item: any }>());
